/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as AuthMigrationdashboardRouteImport } from './routes/_auth/migrationdashboard'
import { Route as AuthMigrationdashboardIndexRouteImport } from './routes/_auth/migrationdashboard/index'
import { Route as AuthDashboardIndexRouteImport } from './routes/_auth/dashboard/index'
import { Route as PublicSignInCallbackRouteImport } from './routes/_public/sign-in_.callback'
import { Route as AuthIntegrationIntegrationRouteImport } from './routes/_auth/integration/$integration'
import { Route as AuthMigrationdashboardMigrationMigrationRouteImport } from './routes/_auth/migrationdashboard/migration/$migration'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const AuthMigrationdashboardRoute = AuthMigrationdashboardRouteImport.update({
  id: '/migrationdashboard',
  path: '/migrationdashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMigrationdashboardIndexRoute =
  AuthMigrationdashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthMigrationdashboardRoute,
  } as any)
const AuthDashboardIndexRoute = AuthDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AuthRoute,
} as any)
const PublicSignInCallbackRoute = PublicSignInCallbackRouteImport.update({
  id: '/sign-in_/callback',
  path: '/sign-in/callback',
  getParentRoute: () => PublicRoute,
} as any)
const AuthIntegrationIntegrationRoute =
  AuthIntegrationIntegrationRouteImport.update({
    id: '/integration/$integration',
    path: '/integration/$integration',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthMigrationdashboardMigrationMigrationRoute =
  AuthMigrationdashboardMigrationMigrationRouteImport.update({
    id: '/migration/$migration',
    path: '/migration/$migration',
    getParentRoute: () => AuthMigrationdashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/migrationdashboard': typeof AuthMigrationdashboardRouteWithChildren
  '/sign-in': typeof PublicSignInRoute
  '/integration/$integration': typeof AuthIntegrationIntegrationRoute
  '/sign-in/callback': typeof PublicSignInCallbackRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/migrationdashboard/': typeof AuthMigrationdashboardIndexRoute
  '/migrationdashboard/migration/$migration': typeof AuthMigrationdashboardMigrationMigrationRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof PublicSignInRoute
  '/integration/$integration': typeof AuthIntegrationIntegrationRoute
  '/sign-in/callback': typeof PublicSignInCallbackRoute
  '/dashboard': typeof AuthDashboardIndexRoute
  '/migrationdashboard': typeof AuthMigrationdashboardIndexRoute
  '/migrationdashboard/migration/$migration': typeof AuthMigrationdashboardMigrationMigrationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_auth/migrationdashboard': typeof AuthMigrationdashboardRouteWithChildren
  '/_public/sign-in': typeof PublicSignInRoute
  '/_auth/integration/$integration': typeof AuthIntegrationIntegrationRoute
  '/_public/sign-in_/callback': typeof PublicSignInCallbackRoute
  '/_auth/dashboard/': typeof AuthDashboardIndexRoute
  '/_auth/migrationdashboard/': typeof AuthMigrationdashboardIndexRoute
  '/_auth/migrationdashboard/migration/$migration': typeof AuthMigrationdashboardMigrationMigrationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/migrationdashboard'
    | '/sign-in'
    | '/integration/$integration'
    | '/sign-in/callback'
    | '/dashboard'
    | '/migrationdashboard/'
    | '/migrationdashboard/migration/$migration'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/integration/$integration'
    | '/sign-in/callback'
    | '/dashboard'
    | '/migrationdashboard'
    | '/migrationdashboard/migration/$migration'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/_auth/migrationdashboard'
    | '/_public/sign-in'
    | '/_auth/integration/$integration'
    | '/_public/sign-in_/callback'
    | '/_auth/dashboard/'
    | '/_auth/migrationdashboard/'
    | '/_auth/migrationdashboard/migration/$migration'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/migrationdashboard': {
      id: '/_auth/migrationdashboard'
      path: '/migrationdashboard'
      fullPath: '/migrationdashboard'
      preLoaderRoute: typeof AuthMigrationdashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/migrationdashboard/': {
      id: '/_auth/migrationdashboard/'
      path: '/'
      fullPath: '/migrationdashboard/'
      preLoaderRoute: typeof AuthMigrationdashboardIndexRouteImport
      parentRoute: typeof AuthMigrationdashboardRoute
    }
    '/_auth/dashboard/': {
      id: '/_auth/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_public/sign-in_/callback': {
      id: '/_public/sign-in_/callback'
      path: '/sign-in/callback'
      fullPath: '/sign-in/callback'
      preLoaderRoute: typeof PublicSignInCallbackRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/integration/$integration': {
      id: '/_auth/integration/$integration'
      path: '/integration/$integration'
      fullPath: '/integration/$integration'
      preLoaderRoute: typeof AuthIntegrationIntegrationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/migrationdashboard/migration/$migration': {
      id: '/_auth/migrationdashboard/migration/$migration'
      path: '/migration/$migration'
      fullPath: '/migrationdashboard/migration/$migration'
      preLoaderRoute: typeof AuthMigrationdashboardMigrationMigrationRouteImport
      parentRoute: typeof AuthMigrationdashboardRoute
    }
  }
}

interface AuthMigrationdashboardRouteChildren {
  AuthMigrationdashboardIndexRoute: typeof AuthMigrationdashboardIndexRoute
  AuthMigrationdashboardMigrationMigrationRoute: typeof AuthMigrationdashboardMigrationMigrationRoute
}

const AuthMigrationdashboardRouteChildren: AuthMigrationdashboardRouteChildren =
  {
    AuthMigrationdashboardIndexRoute: AuthMigrationdashboardIndexRoute,
    AuthMigrationdashboardMigrationMigrationRoute:
      AuthMigrationdashboardMigrationMigrationRoute,
  }

const AuthMigrationdashboardRouteWithChildren =
  AuthMigrationdashboardRoute._addFileChildren(
    AuthMigrationdashboardRouteChildren,
  )

interface AuthRouteChildren {
  AuthMigrationdashboardRoute: typeof AuthMigrationdashboardRouteWithChildren
  AuthIntegrationIntegrationRoute: typeof AuthIntegrationIntegrationRoute
  AuthDashboardIndexRoute: typeof AuthDashboardIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthMigrationdashboardRoute: AuthMigrationdashboardRouteWithChildren,
  AuthIntegrationIntegrationRoute: AuthIntegrationIntegrationRoute,
  AuthDashboardIndexRoute: AuthDashboardIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicSignInRoute: typeof PublicSignInRoute
  PublicSignInCallbackRoute: typeof PublicSignInCallbackRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicSignInRoute: PublicSignInRoute,
  PublicSignInCallbackRoute: PublicSignInCallbackRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
